//
// Copyright (c) 2021 Astute Global, Inc.
//

import { Command } from "ckeditor5";

const DEFAULT_INSERT_TYPE = "text";
const INSERT_TYPES = ["text", "image", "link", "html"];

class ConversationVariableCommand extends Command {
  constructor(editor) {
    super(editor);
    this.set({
      insertType: DEFAULT_INSERT_TYPE,
      variableName: null,
    });
  }

  execute(options) {
    let executeOptions;
    if (!options) {
      if (!this.value) {
        return;
      }

      executeOptions = {
        insertType: this.insertType,
        variableId: this.value,
        variableName: this.variableName,
      };
    } else {
      executeOptions = Object.assign({}, options);
    }
    if (!executeOptions.variableName) {
      executeOptions.variableName = this.editor.config.get(
        "conversationVariable.emptyVariableName",
      );
    }
    const model = this.editor.model;
    model.change((writer) => {
      const conversationVariable = writer.createElement("conversationVariable", executeOptions);
      model.insertContent(conversationVariable);
      writer.setSelection(conversationVariable, "on");
    });
  }

  refresh() {
    const model = this.editor.model;
    const selection = model.document.selection;
    const element = selection.getSelectedElement();
    if (element && element.is("element", "conversationVariable")) {
      this.isEnabled = true;
      this.insertType = element.getAttribute("insertType");
      this.value = element.getAttribute("variableId");
      this.variableName = element.getAttribute("variableName");
    } else {
      const allowedIn = model.schema.findAllowedParent(
        selection.getFirstPosition(),
        "conversationVariable",
      );

      this.isEnabled = !!allowedIn;
      this.insertType = DEFAULT_INSERT_TYPE;
      this.value = "";
      this.variableName = "";
    }
  }
}

export { DEFAULT_INSERT_TYPE, INSERT_TYPES, ConversationVariableCommand };
